import {
	EntityAzurePipelinesContent,
	isAzureDevOpsAvailable,
	isAzurePipelinesAvailable,
} from "@backstage-community/plugin-azure-devops";
import type { Entity } from "@backstage/catalog-model";
import { EntitySwitch } from "@backstage/plugin-catalog";
import {
	EntityGithubActionsContent,
	isGithubActionsAvailable,
} from "@backstage/plugin-github-actions";
import {
	EntityGitlabPipelinesTable,
	isGitlabAvailable,
} from "@immobiliarelabs/backstage-plugin-gitlab";
import {
	LatestPipelineRun,
	isTektonCIAvailable,
} from "@janus-idp/backstage-plugin-tekton";
import Grid from "@mui/material/Grid";
import React from "react";

// NEW: Import GithubWorkflowsContent and isGithubAvailable
import {
	GithubWorkflowsContent,
	isGithubAvailable,
} from "@veecode-platform/backstage-plugin-github-workflows";
import { EmptyState } from "@backstage/core-components";
import Button from "@mui/material/Button";

const ifCIs: ((e: Entity) => boolean)[] = [
	isGithubActionsAvailable,
	isGitlabAvailable,
	isTektonCIAvailable,
	isAzureDevOpsAvailable,
	// NEW: Add isGithubAvailable
	isGithubAvailable,
];

export const isCIsAvailable = (e: Entity) => ifCIs.some((f) => f(e));

export const ciContent = (
	<Grid container spacing={3}>
		<EntitySwitch>
			<EntitySwitch.Case if={isGitlabAvailable}>
				<Grid item xs={12}>
					<EntityGitlabPipelinesTable />
				</Grid>
			</EntitySwitch.Case>
		</EntitySwitch>
		<EntitySwitch>
			<EntitySwitch.Case if={isTektonCIAvailable}>
				<Grid item xs={12}>
					<LatestPipelineRun linkTekton />
				</Grid>
			</EntitySwitch.Case>
		</EntitySwitch>
		<EntitySwitch>
			<EntitySwitch.Case if={isAzureDevOpsAvailable}>
				<Grid item xs={12}>
					<EntityAzurePipelinesContent defaultLimit={25} />
				</Grid>
			</EntitySwitch.Case>
			<EntitySwitch.Case if={isAzurePipelinesAvailable}>
				<Grid item xs={12}>
					<EntityAzurePipelinesContent defaultLimit={25} />
				</Grid>
			</EntitySwitch.Case>
		</EntitySwitch>
		<EntitySwitch>
			<EntitySwitch.Case if={isGithubActionsAvailable}>
				<Grid item xs={12}>
					<EntityGithubActionsContent />
				</Grid>
			</EntitySwitch.Case>
		</EntitySwitch>
		{/* NEW: GithubWorkflowsContent support */}
		<EntitySwitch>
			<EntitySwitch.Case if={isGithubAvailable}>
				<Grid item xs={12}>
					<GithubWorkflowsContent />
				</Grid>
			</EntitySwitch.Case>
		</EntitySwitch>
		{/* NEW: Fallback EmptyState if no CI/CD is available */}
		<EntitySwitch>
			<EntitySwitch.Case>
				<Grid item xs={12}>
					<EmptyState
						title="No CI/CD available for this entity"
						missing="info"
						description="You need to add an annotation to your component if you want to enable CI/CD for it. You can read more about annotations in Backstage by clicking the button below."
						action={
							<Button
								variant="contained"
								color="primary"
								href="https://backstage.io/docs/features/software-catalog/well-known-annotations"
							>
								Read more
							</Button>
						}
					/>
				</Grid>
			</EntitySwitch.Case>
		</EntitySwitch>
	</Grid>
);
